import {Injectable} from '@angular/core';
import {LoanApplicationFlowStep} from './loan-application-flow.step';
import {LoanApplicationInteractor} from '../../interactors/loan-application.interactor';

@Injectable()
export class BasicLoanInfoStep extends LoanApplicationFlowStep {
    private readonly loanApplicationInteractor: LoanApplicationInteractor;

    constructor(loanApplicationInteractor: LoanApplicationInteractor) {
        super();
        this.loanApplicationInteractor = loanApplicationInteractor;
    }

    async isComplete(): Promise<boolean> {
        const application = await this.loanApplicationInteractor.get();
        return !!application && !!application.amount && !!application.reason && !!application.tenure;
    }

    url(): string {
        return this.createBorrowerFlowUrl('loan-info');
    }

    displayName(): string {
        return 'Loan Information';
    }

    description(): string {
        return 'Tell us about your requirement';
    }
}